export function partitionArray<T>(
    arr: T[],
    filterFn: (item: T) => boolean
): { matches: T[]; nonMatches: T[] } {
    const matches: T[] = [];
    const nonMatches: T[] = [];
    arr.forEach((val) => {
        const isMatch = filterFn(val);
        if (isMatch) {
            matches.push(val);
        } else {
            nonMatches.push(val);
        }
    });

    return {
        matches: matches,
        nonMatches: nonMatches,
    };
}
